<div class="row">
  <div class="col-md-3 col-12 col-lg-3">
    <mat-spinner [diameter]="70"></mat-spinner>
  </div>
  <div class="col-md-7 col-12 col-lg-7" id="chargement">
    <div class="row">
      <div class="col-md-12 col-12 col-lg-12">Tarification en cours, veuillez patienter...</div>
    </div>
  </div>

  <div class="col-md-2 col-12 col-lg-2">
    <mat-spinner [diameter]="70"></mat-spinner>
  </div>
</div>
